import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './calculator-uganda-car-finance.component.scss';
var CalculatorUgandaCarFinance = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorUgandaCarFinance, _super);
    function CalculatorUgandaCarFinance(element) {
        return _super.call(this, element) || this;
    }
    CalculatorUgandaCarFinance.prototype.init = function () {
        TooltipsService.initTooltips();
        this.inputLoanAmount = this.element.querySelector('input[name=loan_amount]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputRate = this.element.querySelector('input[name=variable_interest_rate]');
        this.selectAge = this.element.querySelector('select[name=select_age]');
        this.containerMonthly = this.element.querySelector('.js-monthly');
        this.containerDate = this.element.querySelector('.js-date');
        this.containerTotal = this.element.querySelector('.js-total');
        this.containerFees = this.element.querySelector('.js-fees');
        this.containerArrangement = this.element.querySelector('.js-arrangement');
        this.containerBureau = this.element.querySelector('.js-bureau');
        this.containerInsurance = this.element.querySelector('.js-insurance');
        this.containerInterest = this.element.querySelector('.js-interest');
        // attributes
        if (this.element.getAttribute('data-calculator-amount')) {
            this.attrCalcAmount = parseFloat(this.element.getAttribute('data-calculator-amount'));
            this.inputLoanAmount.setAttribute('value', this.attrCalcAmount);
            this.valueLoanAmount = this.inputLoanAmount.value;
            this.inputLoanAmount.value = this.formatter(this.valueLoanAmount);
        }
        else {
            var newValue = this.inputLoanAmount.value.replace(/ /g, '');
            this.valueLoanAmount = parseFloat(newValue);
        }
        if (this.element.getAttribute('data-calculator-month')) {
            this.attrCalcMonth = parseFloat(this.element.getAttribute('data-calculator-month'));
            this.inputTerm.setAttribute('value', this.attrCalcMonth);
            this.valueTerm = this.inputTerm.value;
        }
        else {
            this.valueTerm = this.inputTerm.value;
        }
        if (this.element.getAttribute('data-calculator-rate')) {
            this.attrCalcRate = parseFloat(this.element.getAttribute('data-calculator-rate'));
            this.inputRate.setAttribute('value', this.attrCalcRate);
            this.valueRate = this.inputRate.value;
        }
        else {
            this.valueRate = this.inputRate.value;
        }
        if (this.element.getAttribute('data-arrangement-percentage')) {
            this.attrArrangementFee = parseFloat(this.element.getAttribute('data-arrangement-percentage'));
        }
        else {
            this.attrArrangementFee = 2;
        }
        if (this.element.getAttribute('data-bureau-charge')) {
            this.attrBureauCharge = parseFloat(this.element.getAttribute('data-bureau-charge'));
        }
        else {
            this.attrBureauCharge = 25000;
        }
        if (this.element.getAttribute('data-insurance-rate')) {
            this.attrInsuranceRate = parseFloat(this.element.getAttribute('data-insurance-rate'));
        }
        else {
            this.attrInsuranceRate = 1.3;
        }
        // attributes currency
        this.containerCurrencyLoanAmount = this.element.querySelector('.calculator-form__title--currency');
        this.containerCurrencyEstimated = this.element.querySelector('.calculator-item__title--currency');
        this.containerCurrencyTotal = this.element.querySelector('.js-repayments-currency');
        this.containerCurrencyFees = this.element.querySelector('.js-total-currency');
        if (this.element.getAttribute('data-currency')) {
            this.attrCalcCurrency = this.element.getAttribute('data-currency');
            this.containerCurrencyLoanAmount.innerHTML = this.attrCalcCurrency;
            this.containerCurrencyEstimated.innerHTML = this.attrCalcCurrency;
            this.containerCurrencyTotal.innerHTML = this.attrCalcCurrency;
            this.containerCurrencyFees.innerHTML = this.attrCalcCurrency;
        }
        else {
            this.attrCalcCurrency = 'UGX';
            this.containerCurrencyLoanAmount.innerHTML = this.attrCalcCurrency;
            this.containerCurrencyEstimated.innerHTML = this.attrCalcCurrency;
            this.containerCurrencyTotal.innerHTML = this.attrCalcCurrency;
            this.containerCurrencyFees.innerHTML = this.attrCalcCurrency;
        }
        // attributes button terms and conditions
        this.buttonTcs = this.element.querySelector('.js-tcs-button');
        if (this.element.getAttribute('data-tcs-button-text')) {
            this.attrCalcTcsButtonText = this.element.getAttribute('data-tcs-button-text');
            if (this.element.getAttribute('data-tcs-button-url')) {
                this.attrCalcTcsButtonUrl = this.element.getAttribute('data-tcs-button-url');
            }
            else {
                this.attrCalcTcsButtonUrl = '#';
            }
            this.buttonTcs.innerHTML = this.attrCalcTcsButtonText;
            this.buttonTcs.setAttribute('href', this.attrCalcTcsButtonUrl);
            var parent_1 = this.buttonTcs.closest('.calculator-uganda-personal-loan__result--terms');
            parent_1.classList.remove('d-none');
        }
        // attributes button apply now
        this.buttonApply = this.element.querySelector('.js-apply-button');
        if (this.element.getAttribute('data-apply-button-text')) {
            this.attrCalcApplyButtonText = this.element.getAttribute('data-apply-button-text');
            this.buttonApply.innerHTML = this.attrCalcApplyButtonText;
            if (this.element.getAttribute('data-apply-button-modalid')) {
                this.attrCalcApplyButtonModal = this.element.getAttribute('data-apply-button-modalid');
                this.buttonApply.classList.add('js-apply-now-modal-open');
                this.buttonApply.setAttribute('data-modal', this.attrCalcApplyButtonModal);
                this.buttonApply.setAttribute('href', 'javascript:void(0)');
            }
            else {
                if (this.element.getAttribute('data-apply-button-url')) {
                    this.attrCalcApplyButtonUrl = this.element.getAttribute('data-apply-button-url');
                    this.buttonApply.setAttribute('href', this.attrCalcApplyButtonUrl);
                }
                else {
                    this.attrCalcApplyButtonUrl = '#';
                    this.buttonApply.setAttribute('href', this.attrCalcApplyButtonUrl);
                }
            }
            this.buttonApply.classList.remove('d-none');
        }
        // attributes disclaimer
        this.containerDisclaimer = this.element.querySelector('.js-disclaimer');
        if (this.element.getAttribute('data-disclaimer')) {
            this.attrDisclaimer = this.element.getAttribute('data-disclaimer');
            this.containerDisclaimer.innerHTML = this.attrDisclaimer;
        }
        // button
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.calculate();
    };
    CalculatorUgandaCarFinance.prototype.bindEvents = function () {
        var _this = this;
        if (this.inputLoanAmount) {
            this.inputLoanAmount.addEventListener('keyup', function (evt) {
                var element = undefined;
                if (evt.currentTarget) {
                    element = evt.currentTarget;
                }
                else {
                    element = evt.target;
                }
                var value = element.value;
                if (value.length > 0) {
                    var newValue = value.replace(/ /g, '');
                    _this.valueLoanAmount = parseFloat(newValue);
                    _this.inputLoanAmount.value = _this.formatter(newValue);
                }
                else {
                    _this.valueLoanAmount = 0;
                    _this.inputLoanAmount.value = 0;
                }
            });
        }
        if (this.inputTerm) {
            this.inputTerm.addEventListener('change', function (evt) {
                var element = undefined;
                if (evt.currentTarget) {
                    element = evt.currentTarget;
                }
                else {
                    element = evt.target;
                }
                _this.valueTerm = element.value;
            });
        }
        if (this.inputRate) {
            this.inputRate.addEventListener('change', function (evt) {
                var element = undefined;
                if (evt.currentTarget) {
                    element = evt.currentTarget;
                }
                else {
                    element = evt.target;
                }
                _this.valueRate = element.value;
            });
        }
        if (this.buttonCalculate) {
            this.buttonCalculate.addEventListener('click', function (evt) {
                _this.calculate();
            });
        }
        if (this.buttonReset) {
            this.buttonReset.addEventListener('click', function (evt) {
                setTimeout(function () {
                    var value = _this.inputLoanAmount.value;
                    var newValue = value.replace(/ /g, '');
                    _this.valueLoanAmount = parseFloat(newValue);
                    _this.inputLoanAmount.value = _this.formatter(newValue);
                }, 100);
            });
        }
    };
    CalculatorUgandaCarFinance.prototype.calculate = function () {
        // arrangeMent & bureau charges
        var arrangementFee = this.valueLoanAmount * this.attrArrangementFee / 100;
        var bureauCharges = this.attrBureauCharge;
        // normal value
        var normalValue = this.valueLoanAmount / this.valueTerm;
        normalValue = this.round(normalValue, 2);
        // pmt value
        var total = parseFloat(this.valueLoanAmount) + parseFloat(arrangementFee) + parseFloat(bureauCharges);
        var final = -this.PMT(this.valueRate / 1200, this.valueTerm, this.valueLoanAmount, 0, 0);
        final = this.round(final, 2);
        // interest
        var interestMonth = this.round((final - normalValue), 2);
        var interestTotal = interestMonth * this.valueTerm;
        // new date
        var todaysDate = new Date();
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + 1, 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        // calculations
        var valAmountStart = this.valueLoanAmount;
        var valMonth = 1;
        var valMonthly = 0;
        var valDate = "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear();
        var valTotal = 0;
        var valFees = 0;
        var valArrangement = arrangementFee;
        var valBureau = bureauCharges;
        var valInsurance = 0;
        var valInterest = interestTotal;
        for (var index = 0; index < this.valueTerm; index++) {
            var dumInterest = valAmountStart * (this.valueRate / 100) / 12;
            var dumPrincipal = final - dumInterest;
            var dumInsurance = (valAmountStart / 1000) * this.selectAge.value;
            valInsurance = valInsurance + dumInsurance;
            if (valMonth === 1) {
                valMonthly = final + dumInsurance;
            }
            valAmountStart = valAmountStart - dumPrincipal;
            valMonth++;
        }
        valFees = parseFloat(valArrangement) + parseFloat(valBureau) + parseFloat(valInsurance) + parseFloat(valInterest);
        valTotal = parseFloat(this.valueLoanAmount) + parseFloat(valFees);
        // change
        this.containerMonthly.innerHTML = this.formatter(valMonthly);
        this.containerDate.innerHTML = valDate;
        this.containerTotal.innerHTML = "<div class=\"calculator-uganda-personal-loan__result--summary__value--currency\">" + this.attrCalcCurrency + "</div> " + this.formatter(valTotal);
        this.containerFees.innerHTML = "<div class=\"calculator-uganda-personal-loan__result--summary__value--currency\">" + this.attrCalcCurrency + "</div> " + this.formatter(valFees);
        this.containerArrangement.innerHTML = this.formatter(valArrangement);
        this.containerBureau.innerHTML = this.formatter(valBureau);
        this.containerInsurance.innerHTML = this.formatter(valInsurance);
        this.containerInterest.innerHTML = this.formatter(valInterest);
    };
    CalculatorUgandaCarFinance.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorUgandaCarFinance.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorUgandaCarFinance.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorUgandaCarFinance;
}(Base));
export { CalculatorUgandaCarFinance };



//////////////////
// WEBPACK FOOTER
// ./components-uganda/calculator-uganda-car-finance/calculator-uganda-car-finance.component.ts
// module id = 168
// module chunks = 0